"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectHasMoreResults = exports.selectFetchPaginationResults = exports.selectResultsPaginationKey = exports.selectEventResultEnriched = exports.getEventResultsById = exports.selectLinkedResultEventsBy = exports.selectLinkedResultEvents = exports.selectCurrentResultsLength = exports.selectResultsBySportIdAndByTournamentId = exports.selectResultsByLiveStatus = exports.selectChampionshipsMenuFilter = exports.selectResultCountersIdsList = exports.selectResultCountersList = exports.selectResultsFilterInputSearchTextLength = exports.selectResultsFilterInputSearchText = exports.selectFilterExpandedEventsAndTournamentsLength = exports.selectIsEventInExpandedTournamentsStat = exports.selectIsEventInExpandedEventsStat = exports.selectFilterExpandedTournamentsStatLength = exports.selectFilterExpandedTournamentsStat = exports.selectFilterExpandedEventsStatLength = exports.selectFilterExpandedEventsStat = exports.selectFilterIsLiveResults = exports.selectResultsFilterDate = exports.selectResultsFilterSportId = exports.selectResultsFilterChampionshipId = exports.selectFetchItemsResults = exports.getTournamentResultId = exports.getEventResultId = exports.getResultCounters = exports.getResultsForCurrentSport = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const betweb_openapi_axios_1 = require("betweb-openapi-axios");
const values_1 = __importDefault(require("lodash/values"));
const mapValues_1 = __importDefault(require("lodash/mapValues"));
const values_2 = __importDefault(require("lodash/fp/values"));
const filter_1 = __importDefault(require("lodash/fp/filter"));
const flow_1 = __importDefault(require("lodash/fp/flow"));
const keyBy_1 = __importDefault(require("lodash/fp/keyBy"));
const selectors_1 = require("../CommonDataProvider/selectors");
const results_1 = require("../../utils/results");
const selectors_2 = require("../LogosProvider/selectors");
const utils_1 = require("../LogosProvider/utils");
const slice_1 = require("./slice");
const RESULTS_FOR_SPORT_EMPTY_MAP = {};
const getResultsForCurrentSport = (state) => {
    return (state.resultsProvider.data.resultsBySportAndTournament[state.resultsProvider.filters.currentSportId] || RESULTS_FOR_SPORT_EMPTY_MAP);
};
exports.getResultsForCurrentSport = getResultsForCurrentSport;
const getResultCounters = (state) => state.resultsProvider.data.resultCountersBySport ||
    slice_1.initialState.data.resultCountersBySport;
exports.getResultCounters = getResultCounters;
const getEventResultId = (_state, eventResultId) => eventResultId;
exports.getEventResultId = getEventResultId;
const getTournamentResultId = (_state, tournamentResultId) => tournamentResultId;
exports.getTournamentResultId = getTournamentResultId;
const selectFetchItemsResults = (state) => state.resultsProvider.data.fetchItems.loading ||
    slice_1.initialState.data.fetchItems.loading;
exports.selectFetchItemsResults = selectFetchItemsResults;
const selectResultsFilterChampionshipId = (state) => state.resultsProvider.filters.championshipId ||
    slice_1.initialState.filters.championshipId;
exports.selectResultsFilterChampionshipId = selectResultsFilterChampionshipId;
const selectResultsFilterSportId = (state) => state.resultsProvider.filters.currentSportId ||
    slice_1.initialState.filters.currentSportId;
exports.selectResultsFilterSportId = selectResultsFilterSportId;
const selectResultsFilterDate = (state) => state.resultsProvider.filters.date || slice_1.initialState.filters.date;
exports.selectResultsFilterDate = selectResultsFilterDate;
const selectFilterIsLiveResults = (state) => state.resultsProvider.filters.isByLiveResults ||
    slice_1.initialState.filters.isByLiveResults;
exports.selectFilterIsLiveResults = selectFilterIsLiveResults;
const selectFilterExpandedEventsStat = (state) => state.resultsProvider.filters.expandedEventsStat ||
    slice_1.initialState.filters.expandedEventsStat;
exports.selectFilterExpandedEventsStat = selectFilterExpandedEventsStat;
const selectFilterExpandedEventsStatLength = (state) => (0, exports.selectFilterExpandedEventsStat)(state).length;
exports.selectFilterExpandedEventsStatLength = selectFilterExpandedEventsStatLength;
const selectFilterExpandedTournamentsStat = (state) => state.resultsProvider.filters.expandedTournamentsStat ||
    slice_1.initialState.filters.expandedTournamentsStat;
exports.selectFilterExpandedTournamentsStat = selectFilterExpandedTournamentsStat;
const selectFilterExpandedTournamentsStatLength = (state) => (0, exports.selectFilterExpandedTournamentsStat)(state).length;
exports.selectFilterExpandedTournamentsStatLength = selectFilterExpandedTournamentsStatLength;
exports.selectIsEventInExpandedEventsStat = (0, toolkit_1.createSelector)([exports.selectFilterExpandedEventsStat, exports.getEventResultId], (expandedEventsStat, eventId) => expandedEventsStat.includes(eventId));
exports.selectIsEventInExpandedTournamentsStat = (0, toolkit_1.createSelector)([exports.selectFilterExpandedTournamentsStat, exports.getTournamentResultId], (expandedTournamentsStat, tournamentId) => expandedTournamentsStat.includes(tournamentId));
exports.selectFilterExpandedEventsAndTournamentsLength = (0, toolkit_1.createSelector)([
    exports.selectFilterExpandedEventsStatLength,
    exports.selectFilterExpandedTournamentsStatLength,
], (expandedEventsStatLength, expandedTournamentsStatLength) => expandedEventsStatLength + expandedTournamentsStatLength);
const selectResultsFilterInputSearchText = (state) => state.resultsProvider.filters.inputSearch || slice_1.initialState.filters.inputSearch;
exports.selectResultsFilterInputSearchText = selectResultsFilterInputSearchText;
const selectResultsFilterInputSearchTextLength = (state) => (0, exports.selectResultsFilterInputSearchText)(state).length;
exports.selectResultsFilterInputSearchTextLength = selectResultsFilterInputSearchTextLength;
exports.selectResultCountersList = (0, toolkit_1.createSelector)([selectors_1.selectSports, exports.getResultCounters, exports.selectResultsFilterSportId], (sports, resultCountersIds, currentSportId) => (0, values_1.default)(resultCountersIds)
    .filter(({ count }) => count)
    .map((sport) => ({
    ...(sports[sport.id] || {}),
    ...sport,
    isActive: sport.id === currentSportId,
})));
exports.selectResultCountersIdsList = (0, toolkit_1.createSelector)(exports.getResultCounters, (resultCountersIds) => (0, values_1.default)(resultCountersIds).map((sport) => sport.id));
exports.selectChampionshipsMenuFilter = (0, toolkit_1.createSelector)(exports.getResultsForCurrentSport, (resultsForCurrentSport) => {
    return (0, values_1.default)(resultsForCurrentSport).map(({ tournament, events }) => ({
        value: tournament.id.toString(),
        label: tournament.name,
        isLive: events.some((event) => event.completionStatus === betweb_openapi_axios_1.CompletionStatus.Live),
    }));
});
exports.selectResultsByLiveStatus = (0, toolkit_1.createSelector)([
    exports.getResultsForCurrentSport,
    exports.selectResultsFilterSportId,
    exports.selectFilterIsLiveResults,
], (resultsForCurrentSport, currentSportId, isLiveResults) => {
    if (isLiveResults) {
        const liveResultsForCurrentSport = (0, mapValues_1.default)(resultsForCurrentSport, (result) => {
            const { events, tournament } = result;
            const eventsWithLiveStatus = events === null || events === void 0 ? void 0 : events.filter((event) => event.completionStatus === betweb_openapi_axios_1.CompletionStatus.Live);
            if (eventsWithLiveStatus.length) {
                return {
                    tournament: { ...tournament },
                    events: eventsWithLiveStatus,
                };
            }
            return {
                tournament: { ...tournament },
                events: [],
            };
        });
        const filteredLiveResultsForCurrentSport = (0, flow_1.default)(values_2.default, (0, filter_1.default)((result) => result.events.length), (0, keyBy_1.default)('tournament.id'))(liveResultsForCurrentSport);
        return {
            [currentSportId]: filteredLiveResultsForCurrentSport,
        };
    }
    return { [currentSportId]: resultsForCurrentSport };
});
const RESULTS_BY_SPORT_AND_EMPTY_ARRAY = [];
exports.selectResultsBySportIdAndByTournamentId = (0, toolkit_1.createSelector)([
    exports.selectResultsByLiveStatus,
    exports.selectResultsFilterSportId,
    exports.selectResultsFilterChampionshipId,
    exports.selectResultsFilterInputSearchText,
], (resultsByLiveStatus, currentSportId, championshipId, searchText) => {
    if (championshipId) {
        return searchText.length
            ? (0, results_1.getFilteredResultsBySearch)({
                results: [resultsByLiveStatus[currentSportId][championshipId]],
                searchText,
            })
            : resultsByLiveStatus[currentSportId][championshipId]
                ? [resultsByLiveStatus[currentSportId][championshipId]]
                : RESULTS_BY_SPORT_AND_EMPTY_ARRAY;
    }
    return searchText.length
        ? (0, results_1.getFilteredResultsBySearch)({
            results: (0, values_1.default)(resultsByLiveStatus[currentSportId]),
            searchText,
        })
        : (0, values_1.default)(resultsByLiveStatus[currentSportId]);
});
exports.selectCurrentResultsLength = (0, toolkit_1.createSelector)(exports.selectResultsBySportIdAndByTournamentId, (results) => results.length);
const selectLinkedResultEvents = (state) => state.resultsProvider.data.linkedEvents;
exports.selectLinkedResultEvents = selectLinkedResultEvents;
const LINKED_EVENT_RESULTS_EMPTY_ARRAY = [];
exports.selectLinkedResultEventsBy = (0, toolkit_1.createSelector)([
    exports.selectLinkedResultEvents,
    (_, eventResult) => eventResult,
], (linkedEventResults, eventResult) => {
    if (!eventResult.linkedEvents) {
        return LINKED_EVENT_RESULTS_EMPTY_ARRAY;
    }
    return eventResult.linkedEvents
        .map((linkedEvent) => linkedEventResults[linkedEvent.eventId])
        .filter((event) => event);
});
const getEventResultsById = (state, eventId) => state.resultsProvider.data.eventResults[eventId];
exports.getEventResultsById = getEventResultsById;
exports.selectEventResultEnriched = (0, toolkit_1.createSelector)([
    (state, eventId) => (0, exports.getEventResultsById)(state, eventId),
    (state) => (0, selectors_2.getCompetitorLogos)(state),
], (event, logos) => (0, utils_1.enrichEvent)(event, logos));
const selectResultsPaginationKey = (state) => state.resultsProvider.data.pagination.paginationKey;
exports.selectResultsPaginationKey = selectResultsPaginationKey;
const selectFetchPaginationResults = (state) => state.resultsProvider.data.pagination.paginationLoading;
exports.selectFetchPaginationResults = selectFetchPaginationResults;
const selectHasMoreResults = (state) => state.resultsProvider.data.pagination.hasMore;
exports.selectHasMoreResults = selectHasMoreResults;
//# sourceMappingURL=selectors.js.map